import { lazy } from 'react';

export const lazyComponents = {
  BigCommercePage: lazy(() =>
    import(/* webpackChunkName: 'BigCommercePage' */ '../marketing/bigcommerce/BigCommercePage')
  ),
  CarrierDetailPage: lazy(() =>
    import(
      /*webpackChunkName: 'carrierDetailPage' */
      '../logistics/carrier/carrierDetail/CarrierDetailPage'
    )
  ),
  CashDiscountsFiscalYearButton: lazy(() =>
    import(
      /* webpackChunkName: 'CashDiscountsFiscalYearButton' */
      '../finance/cashDiscounts/CashDiscountsFiscalYearButton'
    )
  ),
  CashDiscountsPage: lazy(() =>
    import(/* webpackChunkName: 'CashDiscountsPage' */ '../finance/cashDiscounts/CashDiscountsPage')
  ),
  CoOpDetailRouterWrapper: lazy(() =>
    import(/* webpackChunkName: 'CoOpDetailRouterWrapper' */ '../components/CoOp/detailPage/CoOpDetailRouterWrapper')
  ),
  CoOpManagementPage: lazy(() =>
    import(/* webpackChunkName: 'CoOpManagementPage' */ '../marketing/coop/CoOpManagementPage')
  ),
  CoOpPage: lazy(() => import(/* webpackChunkName: 'CoOpPage' */ '../sales/coop/CoOpPage')),
  DashboardFilters: lazy(() =>
    import(/* webpackChunkName: 'DashboardFilters' */ '../sales/dashboard/DashboardFilters')
  ),
  DealerDetailRouterWrapper: lazy(() =>
    import(/* webpackChunkName: 'DealerDetailRouterWrapper' */ '../sales/dealers/DealerDetailRouterWrapper')
  ),
  DealerPortalFreeShipping: lazy(() =>
    import(/* webpackChunkName: 'DealerPortalFreeShipping' */ '../dealerPortal/freeShipping/FreeShippingPage')
  ),
  DealersFilterButton: lazy(() =>
    import(/* webpackChunkName: 'DealersFilterButton' */ '../sales/dealers/DealersFilterButton')
  ),
  DealersListPage: lazy(() => import(/* webpackChunkName: "DealersListPage" */ '../sales/dealers/DealersListPage')),
  FinanceCoOpFiscalButton: lazy(() =>
    import(/* webpackChunkName: 'FinanceCoOpFiscalButton' */ '../finance/coOp/FinanceCoOpFiscalButton')
  ),
  FinanceCoOpPage: lazy(() => import(/* webpackChunkName: 'FinanceCoOpPage' */ '../finance/coOp/FinanceCoOpPage')),
  FinanceLinks: lazy(() => import(/* webpackChunkName: 'FinanceLinks' */ '../finance/links/FinanceLinks')),
  FinanceNewDealerList: lazy(() =>
    import(/* webpackChunkName: 'FinanceNewDealerList' */ '../finance/newDealer/FinanceNewDealerList')
  ),
  FinancePaymentTerms: lazy(() =>
    import(/* webpackChunkName: 'FinancePaymentTerms' */ '../finance/paymentTerms/PaymentTermPage')
  ),
  Home: lazy(() => import(/* webpackChunkName: "Home"  */ './Home')),
  InfoTechLinks: lazy(() => import(/* webpackChunkName: 'InfoTechLinks' */ '../it/links/InfoTechLinks')),
  ITPage: lazy(() => import(/* webpackChunkName: "ITPage"  */ '../it/ITPage')),
  ItPermissions: lazy(() => import(/* webpackChunkName: 'ITPermissions' */ '../it/permissions/PermissionsPage')),
  LoadWrapperPage: lazy(() => import(/* webpackChunkName: 'LoadWrapperPage' */ '../logistics/loads/LoadWrapperPage')),
  LogisticsAdminPage: lazy(() =>
    import(/* webpackChunkName: 'LogisticsAdminPage' */ '../logistics/admin/LogisticsAdminPage')
  ),
  LogisticsCalendarPage: lazy(() =>
    import(/* webpackChunkName: 'LogisticsCalendarPage' */ '../logistics/calendar/LogisticsCalendarPage')
  ),
  LogisticsCarrierPage: lazy(() =>
    import(/*webpackChunkName: 'LogisticsCarrierPage' */ '../logistics/carrier/LogisticsCarrierPage')
  ),
  LogisticsDealerPageContainer: lazy(() =>
    import(
      /* webpackChunkName: 'UnallocatedProductSummaryContainer' */ '../logistics/unallocatedProductSummary/UnallocatedProductSummaryContainer'
    )
  ),
  LogisticsFilterButton: lazy(() =>
    import(/* webpackChunkName: 'LogisticsDashboardFilterButton' */ '../logistics/shared/LogisticsFilterButton')
  ),
  LogisticsListPage: lazy(() =>
    import(/* webpackChunkName: 'LogisticsListPage' */ '../sales/logistics/LogisticsListPage')
  ),
  LogisticsMainPage: lazy(() => import(/* webpackChunkName: 'LogisticsMainPage' */ '../logistics/LogisticsMainPage')),
  LogisticsOrderLookup: lazy(() =>
    import(/* webpackChunkName: 'LogisticsOrderLookup' */ '../logistics/orderLookup/OrderLookupWrapper')
  ),
  LogisticsOrderLookupSearch: lazy(() =>
    import(/* webpackChunkName: 'LogisticsOrderLookupSearch' */ '../logistics/orderLookup/OrderLookupSearch')
  ),
  LogisticsPage: lazy(() =>
    import(/* webpackChunkName: 'LogisticsPage' */ '../logistics/dashboard/LogisticsDashboardPage')
  ),
  LogisticsSearchButton: lazy(() =>
    import(/* webpackChunkName: 'LogisticsSearchButton' */ '../logistics/shared/search/LogisticsSearchButton')
  ),
  LogisticsSidebar: lazy(() =>
    import(/* webpackChunkName: 'LogisticsSidebar' */ '../logistics/sidebar/LogisticsSidebar')
  ),
  LogisticsSyncLogEvent: lazy(() =>
    import(/* webpackChunkName: 'LogisticsSyncLogEvent' */ '../logistics/syncEventLog/SyncEventLogPage')
  ),
  LogisticsUsers: lazy(() =>
    import(/* webpackChunkName: 'LogisticsUsers' */ '../logistics/users/LogisticsWarehouseUsersPage')
  ),
  MarketingAdminPage: lazy(() =>
    import(/* webpackChunkName: 'MarketingAdminPage' */ '../marketing/admin/MarketingAdminPage')
  ),
  MarketingCoOpFiscalButton: lazy(() =>
    import(/* webpackChunkName: 'MarketingCoOpFiscalButton' */ '../marketing/coop/MarketingCoOpFiscalButton')
  ),
  MarketingLinks: lazy(() => import(/* webpackChunkName: 'MarketingLinks' */ '../marketing/links/MarketingLinks')),
  MarketingNewDealerList: lazy(() =>
    import(/* webpackChunkName: 'MarketingNewDealerList' */ '../marketing/newDealer/MarketingNewDealerList')
  ),
  NewDealerOrderPageWrapper: lazy(() =>
    import(
      /* webpackChunkName: 'NewDealerOrderPage' */
      '../sales/newDealer/newDealerOrderPage/NewDealerOrderPageWrapper'
    )
  ),
  NewDealerWrapper: lazy(() =>
    import(/* webpackChunkName: 'NewDealerWrapper' */ '../sales/newDealer/newDealerDetailPage/NewDealerWrapper')
  ),
  NewsFeedPage: lazy(() => import(/* webpackChunkName: 'NewsFeedPage' */ '../dealerPortal/newsFeed/NewsFeedPage')),
  OperationsAdmin: lazy(() =>
    import(/* webpackChunkName: 'OperationsAdmin' */ '../operations/admin/OperationsAdminPage')
  ),
  OperationsDepartingSoonPage: lazy(() =>
    import(/* webpackChunkName: 'DepartingSoonPage' */ '../operations/departingSoon/DepartingSoonPage')
  ),
  OperationsUsersPage: lazy(() => import(/* webChunkName: 'UsersPage' */ '../operations/users/OperationsUsersPage')),
  OrderRouterWrapper: lazy(() =>
    import(/* webpackChunkName: 'OrderRouterWrapper' */ '../sales/order/OrderRouterWrapper')
  ),
  PostPageRouterWrapper: lazy(() =>
    import(/* webpackChunkName: 'PostPageRouterWrapper' */ '../dealerPortal/newsFeed/postPage/PostPageRouterWrapper')
  ),
  PreaseasonFiscalButton: lazy(() =>
    import(/* webpackChunkName: 'PreaseasonFiscalButton' */ '../finance/preseason/PreseasonFiscalButton')
  ),
  PreseasonPage: lazy(() => import(/* webpackChunkName: 'PreseasonPage' */ '../finance/preseason/PreseasonPage')),
  ProgramsFiscalButton: lazy(() =>
    import(/* webpackChunkName: 'ProgramsFiscalButton' */ '../finance/programs/ProgramsFiscalButton')
  ),
  ProgramsPage: lazy(() => import(/* webpackChunkName: 'ProgramsPage' */ '../finance/programs/ProgramsPage')),
  ProspectDetailPageWrapper: lazy(() =>
    import(/* webpackChunkName: 'ProspectDetailPageWrapper' */ '../sales/prospects/ProspectDetailPageWrapper')
  ),
  ProspectFilters: lazy(() => import(/* webpackChunkName: 'ProspectFilters' */ '../sales/prospects/ProspectFilters')),
  ProspectsListPage: lazy(() =>
    import(/* webpackChunkName: 'ProspectsListPage' */ '../sales/prospects/ProspectListPage')
  ),
  RegionSettingFiscalYearButton: lazy(() =>
    import(/* webpackChunkName: 'RegionSettingFiscalButton' */ '../sales/regionSettings/RegionSettingFiscalYearButton')
  ),
  RegionSettingsPage: lazy(() =>
    import(/* webpackChunkName: 'RegionSettingsPage' */ '../sales/regionSettings/RegionSettingsPage')
  ),
  SalesAdminPage: lazy(() => import(/* webpackChunkName: 'SalesAdminPage' */ '../sales/admin/SalesAdminPage')),
  SalesCallFilters: lazy(() => import(/* webpackChunkName: 'SalesCallFilters' */ '../sales/calls/SalesCallFilters')),
  SalesCallRouterWrapper: lazy(() =>
    import(/* webpackChunkName: 'SalesCallRouterWrapper' */ '../sales/calls/SalesCallRouterWrapper')
  ),
  SalesComplianceFilters: lazy(() =>
    import(/* webpackChunkName: 'SalesComplianceFilters' */ '../sales/compliance/ComplianceFilters')
  ),
  SalesCompliancePage: lazy(() =>
    import(/* webpackChunkName: 'SalesCompliancePage' */ '../sales/compliance/SalesCompliancePage')
  ),
  SalesCoOpFiscalButton: lazy(() =>
    import(/* webpackChunkName: 'SalesCoOpFiscalButton' */ '../sales/coop/SalesCoOpFiscalButton')
  ),
  SalesDashboardPage: lazy(() =>
    import(/* webpackChunkName: "SalesDashboardPage" */ '../sales/dashboard/SalesDashboardPage')
  ),
  SalesDocumentsPage: lazy(() =>
    import(/* webpackChunkName: 'SalesDocumentsPage' */ '../sales/documents/SalesDocumentsPage')
  ),
  SalesLinks: lazy(() => import(/* webpackChunkName: 'SalesLinks' */ '../sales/links/SalesLinks')),
  SalesNewDealerList: lazy(() =>
    import(/* webpackChunkName: 'SalesNewDealerList' */ '../sales/newDealer/SalesNewDealerList')
  ),
  SalesReportsListPage: lazy(() =>
    import(/* webpackChunkName: 'SalesReportsListPage' */ '../sales/reports/SalesReportsListPage')
  ),
  SalesShipmentPage: lazy(() =>
    import(/* webpackChunkName: 'SalesShipmentPage' */ '../sales/logistics/SalesShipmentPage')
  ),
  ShipmentDetailPageWrapper: lazy(() =>
    import(
      /* webpackChunkName: 'ShipmentDetailPageWrapper' */
      '../shared/logistics/shipmentDetailPage/ShipmentDetailPageWrapper'
    )
  ),
  ShipmentListFilters: lazy(() =>
    import(/* webpackChunkName: 'ShipmentListFilters' */ '../sales/shared/ShipmentList/ShipmentListFilters')
  ),
  TargetedCatalog: lazy(() =>
    import(/* webpackChunkName: 'TargetedCatalog' */ '../shared/targetedCatalog/TargetedCatalogPage')
  )
};
